import React from 'react'
import { Spinner, Table } from 'react-bootstrap'
// import { Link } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import DynamicListBulkActions from './DynamicListBulkActions'
// import { useHistory } from 'react-router-dom'

function AllDynaniclistUi(props) {
  // const history = useHistory()

  const {
    showLoader,
    handleSearchQuery,
    statusTypes,
    handleSelectedstatusType,
    dynamicListTypes,
    selectedstatusType,
    handleSelectedListType,
    selectedListType,
    checkedArray,
    // setCheckedArray,
    dynamicLists,
    // setDynamicLists,
    allHeaders,
    renderTableRow,
    nextToken,
    loadMoreLists,
    setStateValue,
    BulkActionPermission,
  } = props

  let dynamicListsFilteredData = allHeaders.filter(item => item !== 'ID')
  dynamicListsFilteredData = dynamicListsFilteredData.filter(item => item !== 'movieListImage')

  const redirectTopage = () => {
    window.open('createDynamicList')
  }

  // useEffect(() => {
  //   const getPermissions = async () => {
  //     const permissionInput = { mobileNumber: Auth.user.attributes.phone_number }
  //     const userPermissions = await GetUserPermissions(permissionInput)
  //     const permissionsArray =
  //   userPermissions?.userRolesAndPermissions?.reduce(
  //     (flattenedPermissions, role) => [...flattenedPermissions, ...role.permissions.map(permission => permission.name)],
  //     [],
  //   ) || []

  //     setApproveOptionBoolean(
  //       permissionsArray.includes(DefinedPermissions.DisplayApproveMovieOption,
  //       ))

  //     setEDitOptionPermission(
  //       permissionsArray.includes(
  //       DefinedPermissions.AllMoviesEdit,
  //     ))
  //     setDeleteOptionPermission(permissionsArray.includes(
  //       DefinedPermissions.AllMoviesDelete,
  //     ))
  //     setBulkActionPermission(permissionsArray.includes(
  //       DefinedPermissions.AllMoviesBulkAction,
  //     ))
  //   }

  //   getPermissions()
  // }, [])

  return (
    <div>
      {showLoader && <Spinner />}
      <ToastContainer />
      <h3 className='mt-3 mb-3'>All Dynamic Lists</h3>
      <div className='d-flex justify-content-end'>
        {/* <Link href='/createDynamicList'> */}
        <button onClick={redirectTopage} className='btn btn-primary'>
          Add Dynamic List
        </button>
        {/* </Link> */}
      </div>

      <div className='input-group'>
        <div className='form-outline'>
          <label className='form-label' htmlFor='searchLists'>
            Search
          </label>
          <input
            type='search'
            onChange={handleSearchQuery}
            id='searchLists'
            className='form-control'
          />
        </div>
      </div>
      {/* <input
			name='search'
			value={''}
			type='text'
			placeholder='search movies'
			onChange={handleSearchQuery}
		></input> */}
      <div className='row d-flex ml-3 mb-3 mt-3'>
        {statusTypes.map((statusType, index) => (
          <div key={index} className='custom-control custom-radio col-md-2'>
            <input
              disabled={props.searchInput.length !== 0}
              type='radio'
              onClick={() => handleSelectedstatusType(statusType.value)}
              checked={selectedstatusType === statusType.value}
              id={`statusType${statusType.value}`}
              name='statusType'
              className='custom-control-input'
            />
            <label className='custom-control-label' htmlFor={`statusType${statusType.value}`}>
              {statusType.label}
            </label>
          </div>
        ))}
      </div>
      <div className='row d-flex ml-3 mb-3 mt-3'>
        {dynamicListTypes.map((listType, index) => (
          <div key={index} className='custom-control custom-radio col-md-2'>
            <input
              type='radio'
              disabled={props.searchInput.length !== 0}
              onClick={() => handleSelectedListType(listType.value)}
              checked={selectedListType === listType.value}
              id={`listType${listType.value}`}
              name='listType'
              className='custom-control-input'
            />
            <label className='custom-control-label' htmlFor={`listType${listType.value}`}>
              {listType.label}
            </label>
          </div>
        ))}
      </div>
      {BulkActionPermission && <DynamicListBulkActions
        checkedArray={checkedArray}
        // setCheckedArray={setCheckedArray}
        dynamicLists={dynamicLists}
        // setDynamicLists={setDynamicLists}
        setStateValue={setStateValue}
        status={selectedstatusType}
      />}
      {dynamicLists && dynamicLists.length >= 1 ? (
        <Table striped bordered hover>
          <thead>
            <tr>
              {dynamicListsFilteredData.map((head, headIndex) => (
                <th key={headIndex}>{head}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {dynamicLists && dynamicLists.map((row, index) => renderTableRow(row, index))}
          </tbody>
        </Table>
      ) : (
        <div>no data found</div>
      )}
      {dynamicLists &&
        dynamicLists.length >= 1 &&
        nextToken !== null &&
        props.searchInput.length === 0 && (
          <button
            className='btn btn-primary'
            onClick={() => {
              loadMoreLists()
            }}
          >
            LoadMore
          </button>
        )}
    </div>
  )
}

export default AllDynaniclistUi
